import styled from '@emotion/styled';

import {
  blockingColors,
  blockingMetrics,
  blockingTypography,
} from 'design-system/tokens';

const { mobileBreakpoint } = blockingMetrics;

export const Container = styled.div`
  padding: 24px 24px 140px;

  @media (max-width: ${mobileBreakpoint}) {
    padding: 16px 16px 140px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 24px;
`;

export const Title = styled.h1`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.pageTitle.size};
  font-weight: ${blockingTypography.pageTitle.weight};
  line-height: ${blockingTypography.pageTitle.lineHeight};
  color: ${blockingColors.brandBlue};
`;

export const Subtitle = styled.p`
  margin: 0;
  font-family: ${blockingTypography.fontFamily};
  font-size: ${blockingTypography.pageSubtitle.size};
  font-weight: ${blockingTypography.pageSubtitle.weight};
  line-height: ${blockingTypography.pageSubtitle.lineHeight};
  color: ${blockingColors.text};
`;

export const CardsPanel = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background: ${blockingColors.white};
  border-radius: ${blockingMetrics.radiusContainer};

  @media (max-width: ${mobileBreakpoint}) {
    gap: 10px;
    border-radius: ${blockingMetrics.radius};
  }
`;
